import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';

export function imageInterceptor(): HttpInterceptorFn {
  return (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    // Проверяем, что запрос является GET и запрашивает изображение
    if (req.method === 'GET' && req.url.includes('/content/getimage/')) {
      console.log(req.url);
      // Извлекаем имя изображения из URL
      const imageName = req.url.split('/')[3];

      if (imageName) {
        // Формируем новый URL
        const newUrl = `https://localhost:4200/assets/${imageName}.png`;

        // Клонируем запрос с обновленным URL
        const modifiedReq = req.clone({
          url: newUrl,
        });

        // Передаем модифицированный запрос дальше в обработку
        return next(modifiedReq);
      }
    }

    // Если запрос не соответствует условиям, передаем его дальше без изменений
    return next(req);
  };
}
